"use strict";

exports.__esModule = true;
exports.default = void 0;
var _isObject = _interopRequireDefault(require("./isObject.js"));
var _isPrototype = _interopRequireDefault(require("./_isPrototype.js"));
var _nativeKeysIn = _interopRequireDefault(require("./_nativeKeysIn.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!(0, _isObject.default)(object)) {
    return (0, _nativeKeysIn.default)(object);
  }
  var isProto = (0, _isPrototype.default)(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _default = exports.default = baseKeysIn;